module.exports = __webpack_public_path__ + "static/media/calendar-alt.8e424e5c.svg";